const ReportsConfig = {
  collection: "reports",
  fields: ["id", "type.code", "generated_report"],

  adapter: class Report {
    constructor(report) {
      Object.assign(this, report);
    }
    map(collections, maps) {
      this.type = maps.report_types[this.type?.code];
    }
  }
};

export default ReportsConfig;
